
import { Checkbox, IconButton, Box } from '@mui/material';
import "./FichaTecnica.css";
import { FaFileExcel } from "react-icons/fa";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import PermissionGate from "../CadastroPerfilUsuario/PermissionGate";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import '../styles/responsive.css';
// import { saveAs } from "file-saver";

function ItemsFichaTecnicaTabela({ vetor = [], selecionar, custoTotal, loading, selectedItems = [], handleCheckboxChange, onDeleteSelected }) {

  async function exportarParaExcel(vetorCabedal, vetorSolado, vetorMontagem, custoTotalCabedal, custoTotalSolado, custoTotalMontagem, custoTotalGlobal) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Ficha Técnica');

    // Configuração da página
    sheet.pageSetup = {
      orientation: 'landscape',
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 1,
      paperSize: 9,
      margins: { left: 0.7, right: 0.7, top: 0.75, bottom: 0.75, header: 0.3, footer: 0.3 }
    };

    sheet.headerFooter = {
      oddHeader: "&C&\"Arial,Bold\"Ficha Técnica",
      oddFooter: "&CPágina &P de &N"
    };

  // Título principal: usa o nomeModelo do produto sendo exportado, se disponível
  const allItemsForTitle = [...(vetorCabedal || []), ...(vetorSolado || []), ...(vetorMontagem || [])];
  const foundProductName = allItemsForTitle.find(it => it?.produto?.nomeModelo)?.produto?.nomeModelo || allItemsForTitle[0]?.produto?.nomeModelo || '';
  const productTitle = foundProductName ? `PRÉ CUSTO - ${foundProductName}` : 'PRÉ CUSTO';

  sheet.mergeCells('A1:M1');
  const titleCell = sheet.getCell('A1');
  titleCell.value = productTitle;
    titleCell.font = { size: 14, bold: true, color: { argb: 'FFFFFFFF' } };
    titleCell.alignment = { horizontal: 'center' };
    titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF000000' } };

    let currentRow = 3;

    // Função genérica para adicionar blocos
    const adicionarBloco = (titulo, vetor, custoTotal) => {
      // Título da seção (ex: CABEDAL)
      sheet.mergeCells(`A${currentRow}:M${currentRow}`);
      const blocoTitle = sheet.getCell(`A${currentRow}`);
      blocoTitle.value = titulo.toUpperCase();
      blocoTitle.font = { bold: true, size: 12 };
      blocoTitle.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFc9f653' } }; // Verde limão
      blocoTitle.alignment = { horizontal: 'left' };
      currentRow++;

      // Cabeçalho igual ao da imagem
      const headers = [
        'ESTRUTURA', 'COMPONENTES', 'MATÉRIA PRIMA INICIAL', 'COR', 'UM','FORNECEDOR',
        'TAM', 'CONSUMO', 'RENDIMENTO', 'CUSTO MATERIAL R$',
        'CUSTO PEÇA R$', '% EQUIVALENTE'
      ];
      const headerRow = sheet.getRow(currentRow);
      headerRow.values = headers;
      headerRow.font = { bold: true, size: 10 };
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFddebf7' } // Azul claro
      };
      headerRow.alignment = { horizontal: 'center' };
      currentRow++;

      // Dados da seção
      vetor.forEach(obj => {
        const row = sheet.addRow([
          obj.estrutura || '',
          obj.componentes || '',
          obj.materiaPrima?.descricao || '',
          obj.materiaPrima?.cor || '',
          obj.materiaPrima?.umSigla || '',
          obj.materiaPrima?.idFornecedor?.nomeEmpresa || '',
          
          obj.tamanho || '',
          obj.consumo || 0,
          (obj.rendimento?.toFixed(2) || '0.00').replace('.', ','),
          `R$ ${(obj.materiaPrima?.custo || 0).toFixed(3).replace('.', ',')}`,
          `R$ ${(obj.custoPeca || 0).toFixed(2).replace('.', ',')}`,
          `${(obj.equivalente || 0)}`,
          
        ]);
        row.font = { size: 9 };
        row.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        currentRow++;
      });

      // Total da seção
      const totalRow = sheet.addRow(['', '', '', '', '', '', '', '', '', '', 'Custo Total:', `R$ ${custoTotal.toFixed(2).replace('.', ',')}`]);
      totalRow.font = { bold: true };
      totalRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2EFDA' } }; // Verde suave
      totalRow.getCell(12).alignment = { horizontal: 'right' };
      totalRow.getCell(13).alignment = { horizontal: 'center' };
      currentRow += 2;
    };

    // Adiciona os blocos
    adicionarBloco('Cabedal', vetorCabedal, custoTotalCabedal);
    adicionarBloco('Solado', vetorSolado, custoTotalSolado);
    adicionarBloco('Montagem/Acabado', vetorMontagem, custoTotalMontagem);

    // Linha final com custo total
    const totalGlobalRow = sheet.addRow(['', '', '', '', '', '', '', '', '', '', 'CUSTO TOTAL:', `R$ ${custoTotalGlobal.toFixed(2).replace('.', ',')}`]);
    totalGlobalRow.font = { bold: true, size: 11 };
    totalGlobalRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF9CB9C' } }; // Laranja claro
    totalGlobalRow.getCell(12).alignment = { horizontal: 'right' };
    totalGlobalRow.getCell(13).alignment = { horizontal: 'center' };

    // Ajuste de largura de colunas
    const colWidths = [12, 18, 45, 10, 6, 35, 12, 12, 18, 20, 12, 18];
    colWidths.forEach((wch, i) => {
      sheet.getColumn(i + 1).width = wch;
    });

    // Congelar cabeçalho
    sheet.views = [{ state: 'frozen', ySplit: 3 }];

    // Gerar e salvar
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), 'Ficha_Tecnica_Formatada.xlsx');
  }

  function organizarPorBloco(vetor) {
    const cabedal = [];
    const solado = [];
    const montagem = [];

    let totalCabedal = 0;
    let totalSolado = 0;
    let totalMontagem = 0;

    vetor.forEach(item => {
      const estrutura = item.estrutura?.toLowerCase();

      if (estrutura.includes("cabedal")) {
        cabedal.push(item);
        totalCabedal += item.custoPeca || 0;
      } else if (estrutura.includes("solado")) {
        solado.push(item);
        totalSolado += item.custoPeca || 0;
      } else {
        montagem.push(item);
        totalMontagem += item.custoPeca || 0;
      }
    });

    const custoTotal = totalCabedal + totalSolado + totalMontagem;

    return {
      cabedal,
      solado,
      montagem,
      totalCabedal,
      totalSolado,
      totalMontagem,
      custoTotal // Agora também retorna o custo total global
    };
  }

  const handleVerPdf = (pdfId) => {
    console.log("Visualizar/Baixar PDF com ID:", pdfId);
    // Implementar lógica para visualizar ou baixar o PDF
    // Ex: window.open(`/api/pdf/${pdfId}`, '_blank');
  };

  // Group items once and prepare a section renderer to avoid inline IIFE in JSX
  const { cabedal, solado, montagem, totalCabedal, totalSolado, totalMontagem } = organizarPorBloco(vetor);

  const renderSection = (title, items, total = 0) => {
    const color = title === 'Cabedal' ? '#5b8def' : title === 'Solado' ? '#ff8a65' : '#66bb6a';
    const formattedTotal = `R$ ${Number(total || 0).toFixed(2).replace('.', ',')}`;
    return (
      <div key={title} style={{ marginBottom: 18 }}>
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'linear-gradient(90deg, rgba(255,255,255,0.03), rgba(0,0,0,0.02))', padding: '8px 12px', borderRadius: 8, boxShadow: '0 2px 6px rgba(0,0,0,0.06)', marginBottom: 8, border: '1px solid transparent' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 12, height: 12, borderRadius: 3, background: color }} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: '#222', textTransform: 'uppercase', letterSpacing: 0.6 }}>{title}</span>
              <small style={{ color: '#666', marginTop: 2 }}>Items da seção • <strong style={{ color: '#333' }}>{formattedTotal}</strong></small>
            </div>
          </div>
          <div style={{ fontSize: 13, color: '#444' }}>{items ? items.length : 0} item(s)</div>
        </div>
  <table className="table table-responsive table-mobile table-compact" style={{borderCollapse:'separate', borderSpacing:0}}>
          <thead>
            <tr>
              <th className="col-check"></th>
              <th className="col-id">ID</th>
              <th className="col-estrutura">Estrutura</th>
              <th className="col-componentes">Componentes</th>
              <th className="col-materia">Matéria Prima</th>
              <th className="col-codigo">Código</th>
              <th className="col-cor">Cor</th>
              <th className="col-fornecedor">Fornecedor</th>
              <th className="col-um">UM</th>
              <th className="col-tamanho">Tam</th>
              <th className="col-custo-mp">Custo MP</th>
              <th className="col-consumo">Consumo</th>
              <th className="col-rendimento">Rendimento</th>
              <th className="col-custo-peca">Custo Peça</th>
              <th className="col-equivalente">Equiv.</th>
              <th className="col-acoes">Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="16" style={{ textAlign: "center", padding: "20px" }}>
                  <div className="spinner"></div>
                </td>
              </tr>
            ) : items && items.length > 0 ? (
              items.map(item => (
                <tr key={item.id}>
                  <td className="col-check" data-label="" style={{textAlign:'center'}}>
                    <Checkbox
                      checked={selectedItems.includes(item.id)}
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                  </td>
                  <td className="col-id" data-label="Código">{item.id}</td>
                  <td className="col-estrutura" data-label="Estrutura" title={item.estrutura}>{item.estrutura}</td>
                  <td className="col-componentes text-ellipsis" data-label="Componentes" title={item.componentes}>{item.componentes}</td>
                  <td className="col-materia text-ellipsis" data-label="Matéria Prima" title={item.materiaPrima?.descricao}>{item.materiaPrima?.descricao}</td>
                  <td className="col-codigo" data-label="Código" title={item.materiaPrima?.codigoMateria}>{item.materiaPrima?.codigoMateria}</td>
                  <td className="col-cor" data-label="Cor" title={item.materiaPrima?.cor}>{item.materiaPrima?.cor}</td>
                  <td className="col-fornecedor text-ellipsis" data-label="Fornecedor" title={item.materiaPrima?.idFornecedor?.nomeEmpresa}>{item.materiaPrima?.idFornecedor?.nomeEmpresa}</td>
                  <td className="col-um" data-label="UM">{item.materiaPrima?.umSigla}</td>
                  <td className="col-tamanho" data-label="Tam">{item.tamanho}</td>
                  <td className="col-custo-mp" data-label="Custo MP">R$ {Number(item.materiaPrima?.custo || 0).toFixed(2)}</td>
                  <td className="col-consumo" data-label="Consumo">{Number(item.consumo || 0).toFixed(4)}</td>
                  <td className="col-rendimento" data-label="Rendimento">{item.rendimento}</td>
                  <td className="col-custo-peca" data-label="Custo Peça">R$ {Number(item.custoPeca || 0).toFixed(2)}</td>
                  <td className="col-equivalente" data-label="Equiv.">{item.equivalente}</td>
                  <td className="col-acoes" data-label="Ações">
                    <IconButton
                      size="small"
                      onClick={() => selecionar(item.id, item.produto?.idProduto, item.materiaPrima?.id)}
                      color="primary"
                    >
                      <EditIcon />
                    </IconButton>
                    {item.pdfId && (
                      <>
                        <IconButton
                          size="small"
                          onClick={() => handleVerPdf(item.pdfId)}
                          color="secondary"
                          title="Visualizar Encaixe"
                        >
                          <VisibilityIcon />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleVerPdf(item.pdfId)}
                          color="success"
                          title="Baixar PDF"
                        >
                          <DownloadIcon />
                        </IconButton>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="16" style={{ textAlign: "center" }}>
                  Nenhum item encontrado.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <hr />
      </div>
    );
  };

  return (
    <div>
      <Box className="d-flex justify-content-end align-items-center gap-2 ms-auto" sx={{ mb: 2 }}>
        {/* <button className="btn-btn-cadastrar" onClick={() => handleClick(vetor, custoTotal)}>
          Cadastrar no Kunden
        </button> */}
        <button
          className="btn-exportar"
          onClick={() => {
            const {
              cabedal,
              solado,
              montagem,
              totalCabedal,
              totalSolado,
              totalMontagem,
              custoTotal
            } = organizarPorBloco(vetor);

            exportarParaExcel(
              cabedal,
              solado,
              montagem,
              totalCabedal,
              totalSolado,
              totalMontagem,
              custoTotal
            );
          }}
        >
          <FaFileExcel size={18} />
          Exportar para Excel
        </button>
        <h5 className="custo-total-container-sem-margem">
          Custo Total: R$ {Number(custoTotal || 0).toFixed(2)}
        </h5>
      </Box>

      <div className="table-responsive-container">
        {/* Group items into Cabedal / Solado / Montagem (Acabado) */}
  {renderSection('Cabedal', cabedal, totalCabedal)}
  {renderSection('Solado', solado, totalSolado)}
  {renderSection('Acabado', montagem, totalMontagem)}
      </div>

      {selectedItems.length > 0 && (
        <PermissionGate permissions={["fichaTecnicaItensCadastrar"]}>
          <div className="floating-delete-btn">
            <button
              className="btn btn-danger"
              onClick={onDeleteSelected}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Excluindo ({selectedItems.length})...
                </>
              ) : (
                <>
                  <i className="bi bi-trash-fill me-2"></i>
                  Excluir ({selectedItems.length})
                </>
              )}
            </button>
          </div>
        </PermissionGate>
      )}

      <Box className="custo-total-container" sx={{ width: "100%", textAlign: "right" }}>
        <h5 className="fw-bold">
          Custo Total: R$ {Number(custoTotal || 0).toFixed(2)}
        </h5>
      </Box>
    </div>
  );
}

export default ItemsFichaTecnicaTabela;